import { resizeObserver } from '../../utils/dom';
import { supportsMouseInput } from '../utils/support';
import Component from './component';

export default class Marquee extends Component {
  constructor (props) {
    super(props);

    this._bounds = null;
    this._textBounds = null;

    this.onresize = this.onresize.bind(this);
    this.onmouseover = this.onmouseover.bind(this);
    this.onmouseout = this.onmouseout.bind(this);
  }

  getDefaultProps () {
    return {
      content: '',
      speed: 50,
      pauseOnHover: false,
      playOnHover: false,
      autoplay: true
    };
  }

  setProp (name, newValue, update = true) {
    const updated = super.setProp(name, newValue, false);

    if (name === 'content' && updated && this.isAttached()) {
      // stop animating
      if (this.isAnimating()) {
        this.$element.classList.remove('iono-animate');
      }

      this.$content.firstElementChild.innerHTML = newValue;
      this.$duplicate.firstElementChild.innerHTML = newValue;

      this._textBounds = this.$content.firstElementChild.getBoundingClientRect();
    }

    if (update && updated) this.update();

    return updated;
  }

  attach (element) {
    super.attach(element);

    this.$content = this.$('div:first-child');
    this.$duplicate = this.$('div:last-child');

    resizeObserver.observe(this.$element);

    this.$element.addEventListener('resize', this.onresize);

    if (supportsMouseInput()) {
      this.$element.addEventListener('mouseenter', this.onmouseover);
      this.$element.addEventListener('mouseleave', this.onmouseout);
    }
  }

  detach () {
    if (this.isAttached()) {
      this.$element.removeEventListener('resize', this.onresize);

      if (supportsMouseInput()) {
        this.$element.removeEventListener('mouseenter', this.onmouseover);
        this.$element.removeEventListener('mouseleave', this.onmouseout);
      }

      resizeObserver.unobserve(this.$element);
    }

    this.$content = null;
    this.$duplicate = null;

    super.detach();
  }

  render () {
    return `<div class="iono-marquee">
      <div><span>${this.props.content}</span></div>
      <div><span>${this.props.content}</span></div>
    </div>`;
  }

  update (changes = []) {
    if (!this.isAttached()) return;

    const isAnimating = this.isAnimating();
    const shouldAnimate = this.shouldAnimate();

    if (!isAnimating && shouldAnimate) {
      this._updateAnimationDuration();
      this.$element.classList.add('iono-animate');
    } else if (isAnimating && !shouldAnimate) {
      this.$element.classList.remove('iono-animate');
    }
  }

  start () {
    this._manualStarted = true;
    this.update();
  }

  stop () {
    this._manualStarted = false;
    this.update();
  }

  _getBounds () {
    if (!this.isAttached()) return { width: 0 };
    this._bounds = this._bounds || this.$element.getBoundingClientRect();
    return this._bounds;
  }

  _getTextBounds () {
    if (!this.isAttached()) return { width: 0 };
    this._textBounds = this._textBounds || this.$content.firstElementChild.getBoundingClientRect();
    return this._textBounds;
  }

  _updateAnimationDuration () {
    // update animation duration
    const animationDuration = Math.round(this._getTextBounds().width / this.props.speed * 1000);

    this.$content.style.animationDuration = `${animationDuration}ms`;
    this.$duplicate.style.animationDuration = `${animationDuration}ms`;
  }

  shouldAnimate () {
    if (!this.isAttached()) return false;

    if (this._getTextBounds().width <= this._getBounds().width) {
      return false;
    }

    if (this._manualStarted) {
      return true;
    }

    const hovering = this.isHovering();

    // play on hover is enabled and user is hovering
    if (this.props.playOnHover && hovering) {
      return true;
    }

    // pause on hover is enabled and user is not hovering
    if (this.props.pauseOnHover && hovering) {
      return false;
    }

    // autoplay is on
    return this.props.autoplay;
  }

  isAnimating () {
    return this.$element.classList.contains('iono-animate');
  }

  isHovering () {
    return this._hovering;
  }

  onresize (event) {
    if (!this.isAttached()) return;

    this._bounds = event.detail.contentRect;
    this._textBounds = this.$content.firstElementChild.getBoundingClientRect();

    this.update();
  }

  onmouseover (event) {
    if (!this.isAttached()) return;
    this._hovering = true;
    this.update();
  }

  onmouseout (event) {
    if (!this.isAttached()) return;
    this._hovering = false;
    this.update();
  }
}
